module.exports = __webpack_public_path__ + "static/media/destacados-4.065ab5d4.png";